import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly matIconRegistry: MatIconRegistry,
  ) {}

  initIcons() {

    const isParacelsus = environment.style === 'paracelsus'

    const paracelsusReplace = new Map(
      [[
          'exit', '../../assets/icons/exit(1).svg'
        ],
        [
          'chat', '../../assets/icons/spellcheck.svg'
        ],
        [
          'elements-list', '../../assets/icons/menu.svg'
        ],
        [
          'home', '../../assets/icons/home_page.svg'
        ],
        [
          'question', '../../assets/icons/contact_support.svg'
        ],
      ]);



    this.matIconRegistry.addSvgIcon(
      'common-information',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/common-information.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'skills',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/skills.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'input-control',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/input-control.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'learning',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/learning.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'certificate',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/certificate.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'flag',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/flag.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'lock-closed',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/lock-closed.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'lock-opened',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/lock-opened.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'blank',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/blank.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'edit',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/edit.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'order',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/order.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'loupe',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/loupe.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'download',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/download.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'home1',
      this.domSanitizer.bypassSecurityTrustResourceUrl(isParacelsus ? <string> paracelsusReplace.get('home') : '../../assets/icons/home.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'question',
      this.domSanitizer.bypassSecurityTrustResourceUrl(isParacelsus ? <string> paracelsusReplace.get('question') : '../../assets/icons/question.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chat',
      this.domSanitizer.bypassSecurityTrustResourceUrl(isParacelsus ? <string> paracelsusReplace.get('chat') : '../../assets/icons/chat.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'eye',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/eye.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'input',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/input.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'exit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(isParacelsus ? <string> paracelsusReplace.get('exit') : '../../assets/icons/exit.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'placeholder',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/placeholder.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'left-arrow',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/left-arrow.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'right-arrow',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/right-arrow.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'sort-down',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/sort-down.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'sort-up',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/sort-up.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'clock',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/clock.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'success-mark',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/success-mark.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'success-mark-paracelsus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/success-mark-paracelsus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'elements-list',
      this.domSanitizer.bypassSecurityTrustResourceUrl( isParacelsus ? <string> paracelsusReplace.get('elements-list') : '../../assets/icons/elements-list.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'bullet-list',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/bullet-list.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-down',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/chevron-down.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/chevron-left.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/chevron-right.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'correct',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/correct.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'link',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/link.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'nmifo-log',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/nmifo-logo.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'wrong',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/wrong.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/arrow-right.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/quiz-icons/arrow-left.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'plus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/plus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'minus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/minus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'alarm',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/alarm.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cat',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/cat.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'display',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/display.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'list',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/list.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'restart',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/restart.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'info',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/info.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'false',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/false.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/right.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'winner',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/podium_winner_secondary.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-left-unfilled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/chevron-left-unfilled.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-right-unfilled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/chevron-right-unfilled.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'passed',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/passed.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'not-passed',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/not-passed.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'menu-lines',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/menu-lines.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'fact-green-filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/fact-green-filled.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'fact-green-unfilled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/fact-green-unfilled.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'fact-red-filled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/fact-red-filled.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'fact-red-unfilled',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/fact-red-unfilled.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'sort-up-locked',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/sort-up-locked.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'dashboard',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/dashboard.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'power',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/power.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'house',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/house.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'dots',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/dots.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'lungs',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/lungs.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'loader',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../assets/icons/loader.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'passed-isz',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/passed-isz.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'not-passed-isz',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/not-passed-isz.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'info-isz',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/info-isz.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'course-list',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/course-list.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'courses',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/courses.svg')
    );
  }
}
